import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { NdcFeaturesSupportedInNdcNdcCommercialFaqPage } from 'src/app/model/page/group/faq/ndc-features-supported-in-ndc-ndc-commercial-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-features-supported-in-ndc-ndc-commercial-faq-page',
  templateUrl: './ndc-features-supported-in-ndc-ndc-commercial-faq-page.component.html',
  styleUrls: ['./ndc-features-supported-in-ndc-ndc-commercial-faq-page.component.scss']
})
export class NdcFeaturesSupportedInNdcNdcCommercialFaqPageComponent implements OnInit {
  param: number = -1;
  ndcFeaturesSupportInNdcFaqPage: NdcFeaturesSupportedInNdcNdcCommercialFaqPage = {} as NdcFeaturesSupportedInNdcNdcCommercialFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-commercial-features') {
        this.ndcFeaturesSupportInNdcFaqPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => (this.param = params['param']));

    this.ndcFeaturesSupportInNdcFaqPage.sections = [];

    const query = { 'fields.title': "NDC Commercial FAQ#NDC Features - What' s supported in NDC" };
    this.contentfulService.getPageContentWithEntries(query).then((NdcFeaturesSupportedInNdcNdcCommercialFaqPageEntries) => {
      this.mapBanner(NdcFeaturesSupportedInNdcNdcCommercialFaqPageEntries);
      this.mapSections(NdcFeaturesSupportedInNdcNdcCommercialFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.ndcFeaturesSupportInNdcFaqPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }

  private mapBanner(ndcFeaturesSupportInNdcFaqPageEntries: Entry<any>[]) {
    ndcFeaturesSupportInNdcFaqPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.ndcFeaturesSupportInNdcFaqPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapSections(ndcFeaturesSupportInNdcFaqPageEntries: Entry<any>[]) {
    ndcFeaturesSupportInNdcFaqPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcFeaturesSupportInNdcFaqPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    // console.log(entry);
    this.ndcFeaturesSupportInNdcFaqPage.sections.push({
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
